<template>
    <v-card>
        <v-card-title>
            <h3>{{ $t('Выберите тип хранилища ключа для ЭЦП') }}</h3>
        </v-card-title>

        <v-card-text>
            <v-select
                v-model="selectedStorageType"
                :items="typeOfStorages"
                :label="$t('Выберите')"
                class="pl-2 pr-2"
                :disabled="!isDocumentReady || loading || isSigned"
            />

            <div v-if="!isDocumentReady && !errorMessage" class="d-flex align-center mt-2">
                <v-progress-circular indeterminate :size="20" :width="2" color="primary" class="mr-2" />
                <span>{{ $t('Загружается документ...') }}</span>
            </div>

            <!-- статус подписания, как в QR -->
            <div v-if="loading" class="d-flex align-center mt-2">
                <v-progress-circular indeterminate :size="20" :width="2" color="primary" class="mr-2" />
                <span>{{ $t('Подписываем...') }}</span>
            </div>

            <div v-else-if="isSigned" class="d-flex align-center green--text mt-2">
                <v-icon size="20" class="mr-1 green--text">mdi-check</v-icon>
                <span>Документ подписан!</span>
            </div>

            <div v-else-if="errorMessage" class="d-flex align-center red--text mt-2">
                <v-icon size="20" class="mr-1 red--text">mdi-close</v-icon>
                <span>{{ errorMessage }}</span>
            </div>
        </v-card-text>

        <v-card-actions>
            <v-spacer />
            <v-btn
                :loading="loading"
                :disabled="!selectedStorageType || loading || isSigned || !isDocumentReady"
                color="gray"
                rounded
                class="white--text"
                @click="signData"
            >
                {{ $t('Продолжить') }}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { createCMSSignatureFromBase64 } from '@/services/sign.service';
import { NCALYER_NOT_CONNECTED, NCALYER_ERROR_ACTION_CANCELED } from '@/config/consts';

export default {
    name: 'EDSSign',
    props: ['document'],
    data: () => ({
        selectedStorageType: 'PKCS12',
        loading: false,
        errorMessage: '',
        signedData: null,
        isSigned: false
    }),
    computed: {
        typeOfStorages() {
            return [
                { text: this.$t('Ваш Компьютер'), value: 'PKCS12' },
                { text: this.$t('Казтокен'), value: 'AKKaztokenStore' },
                { text: this.$t('Личное Удостоверение'), value: 'AKKZIDCardStore' },
                { text: this.$t('EToken Java 72k'), value: 'AKEToken72KStore' },
                { text: this.$t('AK JaCarta'), value: 'AKJaCartaStore' }
            ];
        },
        isDocumentReady() {
            return typeof this.document === 'string' && this.document.trim().length > 0;
        }
    },
    watch: {
        document() {
            this.errorMessage = '';
            this.isSigned = false;
        }
    },
    methods: {
        async signData() {
            if (!this.isDocumentReady) {
                this.errorMessage = this.$t('Документ ещё не загружен');
                return;
            }
            this.loading = true;
            this.errorMessage = '';
            this.isSigned = false;

            try {
                const { body, status, message, code } = await createCMSSignatureFromBase64(this.document, this.selectedStorageType);

                if (status) {
                    this.signedData = body.result;
                    this.isSigned = true;
                    this.$emit('getEDSData', this.signedData);
                } else {
                    this.isSigned = false;
                    if (code === NCALYER_NOT_CONNECTED) {
                        this.errorMessage = 'Не запущен Ncalayer';
                    } else if (code === NCALYER_ERROR_ACTION_CANCELED) {
                        this.errorMessage = 'Действие было отменено';
                    } else {
                        this.errorMessage = code + ' ' + message;
                    }
                }
            } catch (e) {
                this.isSigned = false;
                this.errorMessage = (e && e.message) || 'Ошибка подписи';
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>
